import React from 'react';
import StarRating from '../../../../../components/StarRating';
import {FormField as FormFieldType, FormData, FormErrors} from '../../../../../types/ContactForm';

interface StarRatingFieldProps {
    field: FormFieldType;
    formData: FormData;
    errors: FormErrors;
    inputCssClass?: string;
    onInputChange: (name: string, value: any) => void;
    onFieldFocus: (fieldName: string) => void;
}

export const StarRatingField: React.FC<StarRatingFieldProps> = ({
                                                                    field,
                                                                    formData,
                                                                    errors,
                                                                    onInputChange,
                                                                    onFieldFocus
                                                                }) => {
    const handleInputChange = (value: any) => {
        onInputChange(field.name, value);
        onFieldFocus(field.name);
    };

    const maxStars = field.maxStars || 5;
    const currentRating = formData[field.name] || 0;

    return (
        <div className={`col-12 col-md-${field.width || 12}`}>
            <div
                className={`form-group ${field.required ? 'required' : ''} ${errors[field.name] ? 'has-error' : ''}`}>
                <label htmlFor={`field-${field.id}`} className="control-label">
                    {field.label}
                </label>
                <div className="star-rating-field mt-2">
                    <StarRating
                        value={currentRating}
                        maxStars={maxStars}
                        onChange={(rating) => handleInputChange(rating)}
                        disabled={false}
                        size="medium"
                        showValue={true}
                    />
                </div>
                {errors[field.name] && (
                    <div className="form-error-msg text-danger">
                        <i className="fa fa-warning"></i> {errors[field.name]}
                    </div>
                )}
            </div>
        </div>
    );
};

